import { render } from "./LoginContent.vue?vue&type=template&id=94f2534a"
import script from "./LoginContent.vue?vue&type=script&lang=js"
export * from "./LoginContent.vue?vue&type=script&lang=js"
script.render = render

export default script